import type { RxJsonSchema } from 'rxdb'
import type { SavedFilter } from '@/lib/types/savedFilter'

export type SavedFilterDocument = SavedFilter

export const savedFilterSchema: RxJsonSchema<SavedFilterDocument> = {
  version: 1,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    name: {
      type: 'string',
      maxLength: 100,
    },
    description: {
      type: ['string', 'null'],
      maxLength: 500,
    },
    filterConfig: {
      type: 'string',
      maxLength: 5000,
    },
    layoutConfig: {
      type: ['string', 'null'],
      maxLength: 5000,
    },
    scope: {
      type: 'string',
      enum: ['project', 'space', 'global'],
      maxLength: 20,
    },
    scopeEntityId: {
      type: ['string', 'null'],
      maxLength: 36,
    },
    permission: {
      type: 'string',
      enum: ['private', 'workspace', 'project'],
      default: 'private',
    },
    ownerId: {
      type: 'string',
      maxLength: 36,
    },
    icon: {
      type: ['string', 'null'],
      maxLength: 50,
    },
    sortOrder: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'name',
    'filterConfig',
    'scope',
    'permission',
    'ownerId',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: [
    'envId',
    'updatedOn',
    ['envId', 'isDeleted'],
    ['envId', 'scope'],
  ],
}

export const savedFilterMigrationStrategies = {
  // v0 -> v1: backfill `layoutConfig` (added, nullable).
  1: (oldDoc: any): any => ({
    ...oldDoc,
    layoutConfig: oldDoc.layoutConfig ?? null,
  }),
}
